import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('LockedPasswordPanelApp => ');

const updateField = createAction('update form value', (fieldId, value) => ({ fieldId, value }));

const onLockedPasswordPanelRequest = createAction('submit form', formRef => ({ formRef }));
const onLockedPasswordPanelSuccess = createAction('submit form success');
const onLockedPasswordPanelFailure = createAction('submit form failure');

export default {
  onLockedPasswordPanelRequest,
  onLockedPasswordPanelSuccess,
  onLockedPasswordPanelFailure,
  updateField,
};
